import CartButton from '@components/cart/CartButton';
import Header from '@components/Header';
import useShop from '@hooks/shop/useShop';
import useProject from '@hooks/useProject';

interface Props {
    shopId: string;
}

function ItemHeader({ shopId }:Props) {
    const shop = useShop(shopId);
    const project = useProject();
    return (
        <Header title={shop?.name || ''}
            trailing={project?.features?.orderEnabled
                ? <CartButton shopId={shopId} /> : undefined}
        />
    );
}

export default ItemHeader;
